import { Order } from "@mezo/api"
import { createSelector } from "@reduxjs/toolkit"

import { Donation } from "../slices/donation"

import {
  selectDonationHistory,
  selectIsDonationHistoryFetching,
} from "./donation"
import { selectIsOrdersHistoryFetching, selectOrdersHistory } from "./store"

export const selectMarketTransactionsHistory = createSelector(
  [selectDonationHistory, selectOrdersHistory],
  (donationsHistory, ordersHistory) => {
    const marketHistory = [...donationsHistory, ...ordersHistory]
      .map((transaction) => {
        const type = "beneficiaryId" in transaction ? "donation" : "order"

        const marketHistoryItem = {
          ...transaction,
          type,
        }

        return marketHistoryItem.type === "donation"
          ? (marketHistoryItem as Donation & { type: "donation" })
          : (marketHistoryItem as Order & { type: "order" })
      })
      .sort((a, b) => b.timestamp - a.timestamp)

    return marketHistory
  },
)

export const selectIsMarketTransactionsHistoryFetching = createSelector(
  [selectIsDonationHistoryFetching, selectIsOrdersHistoryFetching],
  (isDonationHistoryFetching, isOrdersHistoryFetching) =>
    isDonationHistoryFetching || isOrdersHistoryFetching,
)

export const selectMarketProductByTransactionHash = createSelector(
  [
    selectMarketTransactionsHistory,
    (_, transactionHash: string) => transactionHash,
  ],
  (transactions, transactionHash) =>
    transactions.find((tx) => tx.transactionHash === transactionHash),
)
